import React, { useState } from "react";
import Row from "./RowPlant";
import TableList from "../../components/Table";
import { getConnectedStatusString, getFormattedDate } from "../../utils/utils";
import { useTranslation } from "react-i18next";

const List = ({
  items = [],
  add,
  ekloksStatus,
  onConnectDevice = () => {},
  onAddAction = () => {},
  onUpdateRowsAndPages = () => {},
}) => {
  const { t } = useTranslation();
  const getItem = (item) => {
    return {
      ...item,
      ekloks:
        item.ekloks.length > 0 && ekloksStatus?.length > 0
          ? [ekloksStatus.find((eklok) => eklok.id === item.ekloks[0].id)]
          : item.ekloks,
    };
  };

  const [searchValue, setSearchValue] = useState("");
  const filterItems = (items) =>
    items.filter((item) => {
      const name = item.name
        ? item.name.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const country = item.country
        ? item.country.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const city = item.city
        ? item.city.toLowerCase().includes(searchValue.toLowerCase())
        : undefined;
      const formatted_last_mqtt_update =
        item.ekloks.length > 0
          ? getFormattedDate(item.ekloks[0].last_mqtt_update)
          : undefined;
      const last_mqtt_update = formatted_last_mqtt_update
        ? formatted_last_mqtt_update
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        : undefined;
      const connected = getConnectedStatusString(
        getItem(item).ekloks[0]?.connected,
      )
        .toLowerCase()
        .includes(searchValue.toLowerCase());
      return name || country || city || last_mqtt_update || connected;
    });

  const headCells = [
    {
      id: "name",
      label: t("heads_list_installers.name"),
      sortable: true,
    },
    {
      id: "country",
      label: t("heads_list_installers.country"),
      sortable: true,
    },
    {
      id: "city",
      label: t("heads_list_installers.city"),
      sortable: true,
    },
    {
      id: "last_mqtt_update",
      label: t("heads_list_installers.last_update"),
      sortable: true,
    },
    {
      id: "connected",
      label: t("heads_list_installers.connected"),
      sortable: true,
    },
    {
      id: "error",
      label: t("heads_list_installers.alarms"),
      sortable: true,
    },
    {
      id: "connect",
      label: t("heads_list_installers.connect"),
      sortable: false,
    },
  ];

  return (
    <TableList
      headCells={headCells}
      order="asc"
      orderBy="name"
      items={filterItems(items)}
      page={0}
      rowsPerPage={5}
      setSearchValue={setSearchValue}
      add={add}
      addAction={onAddAction}
      onUpdateRowsAndPages={onUpdateRowsAndPages}
    >
      {(item) => (
        <Row
          headCells={headCells}
          onRefreshAction={onUpdateRowsAndPages}
          onConnectDevice={onConnectDevice}
          key={item.id}
          item={getItem(item)}
        />
      )}
    </TableList>
  );
};

export default List;
